@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.que-actions {
  display: flex;
  padding: 5px 10px;
}

.buttons {
  display: flex;
  align-items: center;
}

.archive-button {
  margin-left: 10px;
}

.configuration {
  cursor: pointer;
  margin-right: -10px;
  margin-top: 5px;
  svg {
    padding: 8px;
    fill: @label-que--header--fill-color;
  }
  &:hover {
    > svg {
      fill: @label-que--header--hover--fill-color;
    }
  }
}
